import Auth from 'live/services/authorization'

export function canManageMetadata(): boolean {
    return Auth.Permission.isAdmin || Auth.Permission.METADATA_ADMIN
}

export function canViewMetadata(): boolean {
    return Auth.Permission.isAdmin || Auth.Permission.METADATA_VIEW || Auth.Permission.METADATA_ADMIN
}